import { Box, Flex } from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';

import { TextSemiBold } from 'UiKit/typography';
import { useBriefLiveState } from 'View/brief-live/state';
import scrollTableToLeft from 'Helper/scrollTableToLeft';

import styles from './styles.module.css';

const Tab = ({ t }) => {
  const { state, updateState, resetFilterState } = useBriefLiveState();
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSelectedTab = (selectedTab) => {
    scrollTableToLeft();
    updateState({ selectedTab });
    resetFilterState();
    setSearchParams({ ...Object.fromEntries(searchParams), tab: selectedTab });
  };

  return (
    <Flex className={styles['tab__container']}>
      <Box
        className={`${styles['tab__item']} ${state?.selectedTab === 'talkingPoint' && styles['tab__item--actived']}`}
        onClick={() => updateSelectedTab('talkingPoint')}
      >
        <TextSemiBold className={styles['tab__text']}>{t('tab.talkingPoint')}</TextSemiBold>
      </Box>

      <Box
        className={`${styles['tab__item']} ${state?.selectedTab === 'giveaway' && styles['tab__item--actived']}`}
        onClick={() => updateSelectedTab('giveaway')}
      >
        <TextSemiBold className={styles['tab__text']}>{t('tab.giveaway')}</TextSemiBold>
      </Box>
    </Flex>
  );
};

export default Tab;
